import type { ModuleRenderer } from '../renderer.ts';
import { BoardRenderer } from '../board/BoardRenderer.tsx';

/**
 * `fixture-dice-board` also declares `capabilities.renderer: 'board'` (see manifest.ts) and reuses the exact
 * same shared board renderer as `poc-board` — its `project()` supplies the round roster, dice-derived moves
 * and "Dice round fixture" title/status; `BoardRenderer` and `Board2D` carry no module-specific logic.
 */
export const fixtureDiceBoardClientRenderer: ModuleRenderer = {
  renderer: 'board',
  Component: BoardRenderer,
};
